(function () {

    angular
        .module('app')
        .controller('PretrainedController', PretrainedController);

    PretrainedController.$inject = [
        'scratchService', 'loggerService', 'authService',
        '$mdDialog',
        '$location', '$window'
    ];

    function PretrainedController(scratchService, loggerService, authService, $mdDialog, $location, $window) {
        var vm = this;

        var siteUrl = $location.protocol() + '://' + $location.host();
        if ($location.port()) {
            siteUrl = siteUrl + ':' + $location.port();
        }

        function requireLogin() {
            authService.rememberStateForLogin('pretrained', {});
            return authService.login();
        }

        function openPlatformScratch(scratchUrl) {
            authService.ensurePlatformSessionCookie()
                .finally(function () {
                    $window.location.href = scratchUrl;
                });
        }

        vm.openScratch = function () {
            openPlatformScratch('/scratch/standalone.html');
        };

        vm.openTensorFlowDialog = function (ev) {
            if (!authService.isAuthenticated()) {
                return requireLogin();
            }

            $mdDialog.show({
                controller : ["$scope", function ($scope) {
                    $scope.siteurl = siteUrl;
                    $scope.modeljson = '';
                    $scope.scratchkey = ':scratchkey';
                    $scope.modeltypeid = 10;
                    $scope.validating = false;

                    $scope.hide = function() {
                        $mdDialog.hide();
                    };
                    $scope.cancel = function() {
                        $mdDialog.cancel();
                    };
                    $scope.confirm = function() {
                        $scope.validating = true;
                        scratchService.newTfjsExtension({
                            modelurl : $scope.modeljson,
                            modeltype : $scope.modeltypeid === 10 ? 'teachablemachineimage' : 'graphdefimage'
                        }).then(function (extensionInfo) {
                            openPlatformScratch('/scratch/?url=' + siteUrl + extensionInfo.url);
                            $scope.validating = false;
                            $mdDialog.hide();
                        }).catch(function (err) {
                            loggerService.debug('[ml4kpretrn] Model not found', err);
                            $scope.error = true;
                            $scope.validating = false;
                        });
                    };
                    $scope.generateScratchKey = function(modelJsonUrl, modelTypeId) {
                        $scope.error = false;
                        $scope.scratchkey = encodeURIComponent(JSON.stringify({
                            modelurl : modelJsonUrl,
                            modeltypeid : modelTypeId
                        }));
                    };
                }],
                templateUrl : 'static/components/pretrained/tfjs.tmpl.html',
                targetEvent : ev,
                clickOutsideToClose : true
            });
        };
    }

}());
